import Validator from "./Validator";

export default class JsonEntitiesEntityDataCardContentRowsRowComponentsComponentDataItemsItemNameValidator extends Validator {
    constructor() {
        super();
        this.validationRules = {
            type: 'string',
            empty: false,
            mandatory: false
        };
    }
}
